// Fan vertex schema
// Active air device.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';
import { FanOperationConfigSchema } from '../base/active-device-operation';
import { FanCurveSchema } from '../base/curves';

export const FanVertexSchema = BaseVertexSchema.extend({
  type: z.literal('fan'),
  elevation: ValueWithUnitSchema,
  fan_curve: FanCurveSchema.optional(),
  operation: FanOperationConfigSchema,
});

export type FanVertex = z.infer<typeof FanVertexSchema>;
